var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s)
                if (Object.prototype.hasOwnProperty.call(s, p))
                    t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try {
            step(generator.next(value));
        }
        catch (e) {
            reject(e);
        } }
        function rejected(value) { try {
            step(generator["throw"](value));
        }
        catch (e) {
            reject(e);
        } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function () { if (t[0] & 1)
            throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function () { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f)
            throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _)
            try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
                    return t;
                if (y = 0, t)
                    op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return { value: op[1], done: false };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [0];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2])
                            _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            }
            catch (e) {
                op = [6, e];
                y = 0;
            }
            finally {
                f = t = 0;
            }
        if (op[0] & 5)
            throw op[1];
        return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Modal, message, Image, Button, Tabs } from 'antd';
import { CloseOutlined, CheckCircleOutlined } from '@ant-design/icons';
import { useState } from 'react';
import './NewSchemesPage.scss';
import { useConfirmNewSchemeMutation, useDeleteNewSchemeMutation, useGetAllNewSchemesQuery, } from '@/services/schemesApi';
var NewSchemesPage = function () {
    var _a = useGetAllNewSchemesQuery(), _b = _a.data, schemes = _b === void 0 ? [] : _b, isLoading = _a.isLoading, isError = _a.isError;
    var deleteNewScheme = useDeleteNewSchemeMutation()[0];
    var _c = useState(null), visibleIndex = _c[0], setVisibleIndex = _c[1];
    var confirmNewScheme = useConfirmNewSchemeMutation()[0];
    var _d = useState('all'), filterType = _d[0], setFilterType = _d[1];
    var handleDeleteScheme = function (id) {
        Modal.confirm({
            title: 'Удалить схему?',
            content: 'Вы действительно хотите удалить эту схему?',
            okText: 'Удалить',
            okType: 'danger',
            cancelText: 'Отмена',
            onOk: function () {
                return __awaiter(void 0, void 0, void 0, function () {
                    var error_1;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                _a.trys.push([0, 2, , 3]);
                                return [4 /*yield*/, deleteNewScheme(id).unwrap()];
                            case 1:
                                _a.sent();
                                message.success('Схема удалена');
                                return [3 /*break*/, 3];
                            case 2:
                                error_1 = _a.sent();
                                message.error('Ошибка при удалении схемы');
                                return [3 /*break*/, 3];
                            case 3: return [2 /*return*/];
                        }
                    });
                });
            },
        });
    };
    var handleConfirmScheme = function (schemeId) {
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                Modal.confirm({
                    title: 'Подтвердить схему?',
                    content: 'Схема попадёт в раздел «Подтверждённые», пользователю будет начислена награда. В карты ресторана схема не добавляется.',
                    okText: 'Подтвердить',
                    cancelText: 'Отмена',
                    onOk: function () {
                        return __awaiter(void 0, void 0, void 0, function () {
                            var err_1;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        _a.trys.push([0, 2, , 3]);
                                        return [4 /*yield*/, confirmNewScheme(schemeId).unwrap()];
                                    case 1:
                                        _a.sent();
                                        message.success("\u0421\u0445\u0435\u043C\u0430 \u2116".concat(schemeId, " \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0430, \u043D\u0430\u0433\u0440\u0430\u0434\u0430 \u043D\u0430\u0447\u0438\u0441\u043B\u0435\u043D\u0430 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044E"));
                                        return [3 /*break*/, 3];
                                    case 2:
                                        err_1 = _a.sent();
                                        console.error(err_1);
                                        message.error('Ошибка при подтверждении схемы');
                                        return [3 /*break*/, 3];
                                    case 3: return [2 /*return*/];
                                }
                            });
                        });
                    },
                });
                return [2 /*return*/];
            });
        });
    };
    if (isLoading)
        return _jsx("p", { children: "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430 \u0441\u0445\u0435\u043C..." });
    if (isError)
        return _jsx("p", { children: "\u041E\u0448\u0438\u0431\u043A\u0430 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0438 \u0441\u0445\u0435\u043C" });
    // Фильтруем схемы по выбранному типу
    var filteredSchemes = schemes.filter(function (scheme) {
        if (filterType === 'confirmed')
            return scheme.isConfirmed;
        if (filterType === 'unconfirmed')
            return !scheme.isConfirmed;
        return true; // 'all'
    });
    var tabItems = [
        { key: 'all', label: "\u0412\u0441\u0435 (".concat(schemes.length, ")") },
        { key: 'unconfirmed', label: "\u041D\u0430 \u043C\u043E\u0434\u0435\u0440\u0430\u0446\u0438\u0438 (".concat(schemes.filter(function (s) { return !s.isConfirmed; }).length, ")") },
        { key: 'confirmed', label: "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u043D\u044B\u0435 (".concat(schemes.filter(function (s) { return s.isConfirmed; }).length, ")") },
    ];
    return (_jsxs("div", __assign({ className: "NewSchemesPage" }, { children: [_jsx("div", __assign({ className: "titleBlock" }, { children: _jsx("span", { children: "\u0421\u0445\u0435\u043C\u044B \u0437\u0430\u043B\u043E\u0432 \u043E\u0442 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439" }) })), _jsx(Tabs, { activeKey: filterType, onChange: function (key) { return setFilterType(key); }, items: tabItems, style: { marginBottom: 20, padding: '0 5%' } }), _jsx("div", __assign({ className: "schemesGrid", style: { display: 'flex', flexWrap: 'wrap', gap: 16, width: '90%', margin: 'auto' } }, { children: _jsx(Image.PreviewGroup, __assign({ preview: {
                        visible: visibleIndex !== null,
                        current: visibleIndex !== null && visibleIndex !== void 0 ? visibleIndex : 0,
                        onVisibleChange: function (visible) {
                            if (!visible)
                                setVisibleIndex(null);
                        },
                    } }, { children: filteredSchemes.map(function (scheme, index) {
                        var _a, _b;
                        return (_jsxs("div", __assign({ style: {
                                width: 200,
                                border: '1px solid #eee',
                                borderRadius: 8,
                                padding: 8,
                                boxShadow: '0 2px 6px rgb(0 0 0 / 0.1)',
                                backgroundColor: '#fff',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'space-between',
                            } }, { children: [_jsxs("div", __assign({ onClick: function () { return setVisibleIndex(index); }, style: { cursor: 'pointer', position: 'relative' } }, { children: [_jsx(CloseOutlined, { onClick: function (e) {
                                                e.stopPropagation();
                                                handleDeleteScheme(scheme.id);
                                            }, style: {
                                                position: 'absolute',
                                                top: 6,
                                                right: 6,
                                                color: '#fff',
                                                fontSize: 14,
                                                cursor: 'pointer',
                                                backgroundColor: 'rgba(0,0,0,0.5)',
                                                padding: 4,
                                                borderRadius: '50%',
                                                zIndex: 1,
                                            } }), _jsx(Image, { src: scheme.fileUrl, alt: scheme.fileName, style: { width: '100%', height: 140, objectFit: 'cover', borderRadius: 8 } })] })), _jsxs("div", __assign({ style: { textAlign: 'center', marginTop: 8 } }, { children: [_jsx("p", __assign({ style: { fontWeight: 'bold', fontSize: 14 } }, { children: scheme.fileName })), ((_a = scheme.user) === null || _a === void 0 ? void 0 : _a.fullName) && (_jsxs("p", __assign({ style: { fontSize: 12, color: '#555' } }, { children: ["\u0410\u0432\u0442\u043E\u0440: ", scheme.user.fullName] }))), ((_b = scheme.restaurant) === null || _b === void 0 ? void 0 : _b.name) && (_jsxs("p", __assign({ style: { fontSize: 12, color: '#555' } }, { children: ["\u0420\u0435\u0441\u0442\u043E\u0440\u0430\u043D: ", scheme.restaurant.name] }))), (scheme === null || scheme === void 0 ? void 0 : scheme.isConfirmed) && (_jsxs("div", __assign({ style: { marginTop: 4, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 4 } }, { children: [_jsx(CheckCircleOutlined, { style: { color: '#52c41a', fontSize: 16 } }), _jsx("span", __assign({ style: { fontSize: 12, color: '#52c41a', fontWeight: 500 } }, { children: "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u043E" }))] })))] })), _jsx(Button, __assign({ type: "primary", block: true, size: "small", style: { marginTop: 8 }, disabled: scheme === null || scheme === void 0 ? void 0 : scheme.isConfirmed, onClick: function () { return handleConfirmScheme(scheme.id); } }, { children: "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044C" }))] }), scheme.id));
                    }) })) }))] })));
};
export default NewSchemesPage;
